import React, { useEffect } from "react";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { AudioOutlined, AudioMutedOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

const config = {
  speech_listening_label: <span>Ouvindo...</span>,
  speech_language: `pt-BR`,
  speech_interim: false,
  speech_continuous: false,
  speech_hold_to_talk: false,
};

const SpeechComponent = ({ onText = () => {}, onFinish = () => {} }) => {
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
    isMicrophoneAvailable,
  } = useSpeechRecognition();

  const startListening = () => {
    resetTranscript();

    SpeechRecognition.startListening({
      continuous: config.speech_continuous,
      language: config.speech_language,
      interimResults: config.speech_interim,
    });
  };

  const stopListening = () => {
    setTimeout(() => SpeechRecognition.stopListening(), 300);
  };

  const toogleListening = () => {
    if (listening) stopListening();
    else startListening();
  };

  const getControlProps = () => {
    const controls = {};

    if (config.speech_hold_to_talk) {
      controls.onTouchStart = startListening;
      controls.onMouseDown = startListening;
      controls.onTouchEnd = stopListening;
      controls.onMouseUp = stopListening;
    } else {
      controls.onTouchStart = toogleListening;
      controls.onMouseDown = toogleListening;
    }

    return controls;
  };

  if (browserSupportsSpeechRecognition) {
    SpeechRecognition.getRecognition().onspeechend = () => onFinish(transcript);
  }

  useEffect(() => {
    if (transcript) {
      onText(transcript);
    }
  }, [transcript]);

  if (!browserSupportsSpeechRecognition) {
    return (
      <Tooltip title="Seu navegador não suporta o reconhecimento de voz.">
        <AudioMutedOutlined />
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Pressione para falar">
      <div
        style={{
          width: "auto",
          display: "flex",
          alignItems: "center",
        }}
        id="bn_search_icon"
      >
        <AudioOutlined
          style={{
            fontSize: 19,
            cursor: "pointer",
          }}
          {...getControlProps()}
        />

        {isMicrophoneAvailable && listening && (
          <span style={{ marginLeft: "5px" }}>
            {config.speech_listening_label}
          </span>
        )}
      </div>
    </Tooltip>
  );
};

export default SpeechComponent;
